import { View } from './view'

export const LoanBonusCalculator = View
